import {
  DRUPAL_NODE_DISPLAY,
  type DrupalImage,
  type DrupalNodePage,
  type DrupalTerm,
} from '@commons/types/drupal';

import EventNodeCard from './Card';
import EventNodeFeatured from './Featured';
import EventNodeFeaturedTile from './FeaturedTile';
import EventNodeLabel from './Label';
import EventNodeSmallCard from './SmallCard';
import EventNodeTeaser from './Teaser';

/**
 * Type definition of a Event node properties.
 */

export type EventNodeProps = DrupalNodePage & {
  customDate: string;
  image?: DrupalImage;
  format?: DrupalTerm;
  authors?: string;
  summary?: string;
};

/**
 * Event node component.
 *
 * Renders a component based on the display type.
 */

export const EventNode = (props: EventNodeProps) => {
  switch (props.display) {
    default:
    case DRUPAL_NODE_DISPLAY.Default:
    case DRUPAL_NODE_DISPLAY.Label:
      return <EventNodeLabel {...props} />;
    case DRUPAL_NODE_DISPLAY.Teaser:
      return <EventNodeTeaser {...props} />;
    case DRUPAL_NODE_DISPLAY.Card:
      return <EventNodeCard {...props} />;
    case DRUPAL_NODE_DISPLAY.SmallCard:
      return <EventNodeSmallCard {...props} />;
    case DRUPAL_NODE_DISPLAY.Featured:
      return <EventNodeFeatured {...props} />;
    case DRUPAL_NODE_DISPLAY.FeaturedTile:
      return <EventNodeFeaturedTile {...props} />;
  }
};

export default EventNode;
